/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import React from 'react'
import { getImageThumbnailId } from '@sportninja/common/reducers/helpers'

const TEAM_PLACEHOLDER = '/images/generic_placeholders/placeholder_team.png'

interface Props {
  /** Anything carrying the API `image` — the thumbnail helper reads it. */
  team: { image?: unknown }
  size: 24 | 48
}

/** A team's logo thumbnail, falling back to the team placeholder. */
const TeamLogo = ({ team, size }: Props) => {
  const handleError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    const img = event.currentTarget
    img.onerror = null
    img.src = TEAM_PLACEHOLDER
  }

  return (
    <img
      css={logoStyle}
      src={getImageThumbnailId(team) || TEAM_PLACEHOLDER}
      width={size}
      height={size}
      alt=''
      onError={handleError}
    />
  )
}

export default TeamLogo

const logoStyle = css`
  flex-shrink: 0;
  object-fit: contain;
  border-radius: 8px;
`
